"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCell = exports.TableHeaderCell = exports.TableRow = exports.TableFooter = exports.TableBody = exports.TableHeader = exports.Table = void 0;
const React = require("react");
const colors_1 = require("../../../../types/colors");
const states_1 = require("../../../../types/states");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "Table");
const Table = ({ children, type = "", alignment = "", sizing = "", preset = "", className = "" }) => (React.createElement("table", { className: css("", `-${type}`, `-${sizing}`, `-${alignment}`, `-preset-${preset}`, { className }) }, children));
exports.Table = Table;
const TableHeader = ({ children }) => (React.createElement("thead", null, children));
exports.TableHeader = TableHeader;
const TableBody = ({ children }) => (React.createElement("tbody", null, children));
exports.TableBody = TableBody;
const TableFooter = ({ children }) => (React.createElement("tfoot", null, children));
exports.TableFooter = TableFooter;
const TableRow = ({ children, variant = colors_1.TColorVariants.None, urgent = false, id = "", className = "" }) => {
    return (React.createElement("tr", { className: css(`-${variant}`, {
            "-urgent": urgent,
            className
        }), "data-test": id }, children));
};
exports.TableRow = TableRow;
const TableHeaderCell = ({ colSpan = 1, position, width, children }) => {
    const styleWidth = {
        width: width
    };
    return (React.createElement("th", { colSpan: colSpan, style: styleWidth, className: css(`-${position}`) }, children));
};
exports.TableHeaderCell = TableHeaderCell;
const TableCell = ({ children, colSpan = 1, position, state = states_1.TStates.None, id = "", urgent = false, classes = "", className = "" }) => (React.createElement("td", { colSpan: colSpan, className: css({
        [`-${state}`]: true,
        [`-${position}`]: true,
        [`-${classes}`]: true,
        className
    }), "data-test": id },
    urgent && React.createElement("div", { className: css("-urgent") }),
    children));
exports.TableCell = TableCell;
//# sourceMappingURL=index.js.map